<!-- card 6 -->
<div
  class="w-full rounded border border-[#e0e6ed] bg-white p-5 shadow-[4px_6px_10px_-3px_#bfc9d4] dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none"
>
  <div class="text-[#515365] dark:text-white-light">
    <form class="space-y-5" [formGroup]="form">
      <div>
        <label for="actionCode">Code:</label>
        <input
          id="actionCode"
          type="text"
          placeholder="Enter Category Code"
          class="form-input"
          formControlName="code"
        />
        <form-error
          [form]="form"
          controlName="code"
          [validations]="masterCategoryFormValidations.code"></form-error>
      </div>

      <div>
        <label for="actionName">Name:</label>
        <input
          id="actionName"
          type="text"
          placeholder="Enter Category Name"
          class="form-input"
          formControlName="name"
        />
        <form-error
          [form]="form"
          controlName="name"
          [validations]="masterCategoryFormValidations.name"></form-error>
      </div>

      <div>
        <label>Status:</label>
        <ng-select
          [items]="activeStatus"
          [clearable]="true"
          placeholder="Select Status"
          class="custom-multiselect w-full"
          formControlName="active"
          bindLabel="label"
          bindValue="value"
        >
        </ng-select>
        <form-error
          [form]="form"
          controlName="active"
          [validations]="masterCategoryFormValidations.active"></form-error>
      </div>

      <button
        [disabled]="form.invalid || loading"
        type="button"
        class="btn btn-success mt-4 w-full md:w-[180px]"
        (click)="saveData()"
      >
        <span
          *ngIf="loading"
          class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"
        ></span>
        Submit
      </button>
    </form>
  </div>
</div>
